import {createSchoolStepFromJson, SchoolModuleStep} from "./SchoolModuleSteps";
import {SchoolModuleProgress} from "./SchoolModuleProgress";

export class SchoolModule {
  id: number;

  title: string;
  description: string;
  difficulty: number;

  sheet: any;
  content: SchoolModuleStep[];

  progress: SchoolModuleProgress;
  relatedVersions: any[];

  isFree: boolean

  constructor(json: any) {
    this.id = json.id;

    this.title = json.title;
    this.description = json.description;
    this.difficulty = json.difficulty;

    this.sheet = json.sheet;
    this.content = json.content.map((step: any, index: number) => createSchoolStepFromJson(step, json.id, index));
    this.progress = new SchoolModuleProgress(json.school_module_progress)

    this.isFree = json.is_free

    this.relatedVersions = json.related_piece_versions;
  }
}

